import { render } from "./BrainPicker.vue?vue&type=template&id=641f2976&scoped=true&ts=true"
import script from "./BrainPicker.vue?vue&type=script&lang=ts"
export * from "./BrainPicker.vue?vue&type=script&lang=ts"

import "./BrainPicker.vue?vue&type=style&index=0&id=641f2976&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641f2976"]])

export default __exports__